var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"color":"#F0F0F0"}},[_c('v-content',{staticClass:"grey lighten-2"},[_c('LoginForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }